module.exports = __webpack_public_path__ + "static/media/odd-still.00fbe21e.jpg";